<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>FAMILIAS</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/familias']" class="nav-link m-1 pl-3 pr-3 disabled" tabindex="-1" aria-disabled="true">Familias</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/calificacion']" class="nav-link m-1 pl-3 pr-3 ">Calificación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/ofertas-de-licitacion']" class="nav-link m-1 pl-3 pr-3 "> Ofertas de Licitación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/postulantes-ofertas']" class="nav-link m-1 pl-3 pr-3" tabindex="-1" aria-disabled="true"> Postulantes por oferta</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/consultas-reportes']" class="nav-link m-1 pl-3 pr-3 "> Consultas/Reportes </a>
                    </li> -->
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/login']" class="nav-link cerrar m-1 pl-3 pr-3 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pb-5 mt-5">
            <div class="col-12 mb-1">
                <div class="row FlstLi mb-2">
                    <div class="col-6 col-md-6 col-lg-3 text-left my-2 ">
                        <button type="submit" class="mr-2" (click)="addFamilia()"> Agregar Nueva Familia</button>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mx-auto">
                <div class="FlstLi table-responsive">
                    <table class="Ftabla Ftablon table dDoce">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">Familia</th>
                            <th scope="col" class="pl-2 pr-2">Activa</th>
                        </tr>
                        <tr></tr>

                        <tbody class="tablaBlq" *ngFor="let familia of familias | paginate: { itemsPerPage: 10, currentPage: p }">
                            <tr>
                                <td class="pl-2 pr-2 align-middle" (click)="change(familia)">{{familia.familia}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(familia)">{{familia.activa ? 'Si' : 'No'}}</td>
                            </tr>
                            <tr></tr>
                        </tbody>
                    </table>
                </div>
                <pagination-controls previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="p = $event"></pagination-controls>
            </div>
        </div>
        <div class="col-12 alerta-confirmar blqCtr text-center" *ngIf="this.editar">
            <div class="row mb-2">
                <h4>Datos de la Familia</h4>
            </div>
            <form  ngNativeValidate #Update="ngForm" (ngSubmit)="UpdateFamili(Update)"  class="pb-3 row">
                <div class="row">
                    <div class="form-group col-6 text-left">
                        <input [(ngModel)]="estatusUpdate" name="estatusUpdate" type="checkbox" id="estatusUpdate" class="form-check-input" checked>
                        <label for="estatusUpdate" class="form-check-label">&nbsp;Activa</label>
                    </div>
                    <div class="form-group col-12 text-left">
                        <label for="familiaUpdate">Familia</label>
                        <input [(ngModel)]="familiaUpdate" name="familiaUpdate" type="text" id="familiaUpdate" maxlength="50" required class="form-control">
                    </div>
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Actualizar </button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-12 alerta-confirmar blqCtr text-center" *ngIf="this.addd">
            <div class="row mb-2">
                <h4>Datos de la Familia</h4>
            </div>
            <form  #f="ngForm" (ngSubmit)="confirmacionAgregar(f)" ngNativeValidate class="pb-3 row">
                <div class="row">
                    <div class="form-group col-12 text-left">
                        <label for="familia">Familia</label>
                        <input ngModel name="familia" type="text" id="familia" maxlength="50" required class="form-control">
                    </div>
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Guardar y Salir</button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>


        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>¿La información que ingreso es correcta?</p>
            <button class="btn-confirmar mr-2" (click)="closeok()">Aceptar</button>
            <button class="ml-2 redBtn" (click)="closefail()"> Cancelar</button>
        </div>
	</div>

</div>